import { BiSolidEditAlt } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";

const cellAlign = (a) =>
  a === "left" ? "text-left" : a === "right" ? "text-right" : "text-center";

export default function Table(props) {
  const {
    columns = [],
    data = [],
    noRecordsMessage = "No records found",
    showActions = true,
    onEdit,
    onDelete,
    checkbox,
  } = props;

  const cols = Array.isArray(columns) ? columns : [];
  const rows = Array.isArray(data) ? data : [];

  const idsOnPage =
    checkbox?.idField
      ? rows
        .map((r) => r?.[checkbox.idField])
        .filter((x) => x !== undefined && x !== null)
      : [];

  const allSelected =
    idsOnPage.length > 0 &&
    idsOnPage.every((id) => (checkbox?.selected ?? []).includes(id));

  return (
    <div className="overflow-x-auto rounded-md border border-slate-300 bg-white">
      <table className="w-full text-[13px] border-collapse">
        {cols.some((c) => c.w) && (
          <colgroup>
            {checkbox && <col className="w-10" />}
            {cols.map((c, i) => (
              <col key={i} className={c.w ?? "w-auto"} />
            ))}
            {showActions && <col className="w-20" />}
          </colgroup>
        )}

        <thead className="bg-slate-50 text-slate-800 sticky top-0 z-10">
          <tr className="text-[12px] font-semibold tracking-wide">
            {checkbox && (
              <th className="border border-slate-200 p-1 text-center align-middle">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) =>
                    checkbox?.onToggleAll?.(idsOnPage, e.target.checked)
                  }
                />
              </th>
            )}
            {cols.map((col, i) => (
              <th
                key={i}
                className={`p-1 border border-slate-200 uppercase ${cellAlign(
                  col.align
                )}`}
              >
                {col.label}
              </th>
            ))}
            {showActions && (
              <th className="p-1 border border-slate-200 uppercase text-center">
                Actions
              </th>
            )}
          </tr>
        </thead>

        <tbody className="text-slate-800">
          {rows.length > 0 ? (
            rows.map((row, idx) => (
              <tr
                key={row?.id ?? row?.key ?? idx}
                className="hover:bg-slate-50 transition"
              >
                {checkbox && (
                  <td className="border border-slate-200 p-1 text-center">
                    <input
                      type="checkbox"
                      checked={(checkbox?.selected ?? []).includes(
                        row[checkbox.idField]
                      )}
                      onChange={(e) =>
                        checkbox?.onToggle?.(
                          row[checkbox.idField],
                          e.target.checked
                        )
                      }
                    />
                  </td>
                )}

                {cols.map((col, cidx) => {
                  const val = row[col.key];
                  const content =
                    col.type === "status" ? (
                      <span
                        className={`inline-block px-2 py-1 rounded text-[12px] ${String(val).toLowerCase() === "done"
                          ? "bg-green-100 text-green-700"
                          : "bg-slate-100 text-slate-700"
                          }`}
                      >
                        {val}
                      </span>
                    ) : col.render
                      ? col.render(val, row, idx)
                      : val;

                  return (
                    <td
                      key={cidx}
                      className={`p-1 align-middle ${col.bordered === false ? "" : "border border-slate-200"
                        } ${cellAlign(col.align)}`}
                    >
                      {content}
                    </td>
                  );
                })}

                {showActions && (
                  <td className="p-1 border border-slate-200 text-center">
                    <div className="inline-flex gap-2">
                      {onEdit && (
                        <button
                          title="Edit"
                          className="p-[6px] bg-[#e4ecfa] text-[#405189] rounded hover:bg-[#d8e4f9]"
                          onClick={() => onEdit(row)}
                        >
                          <BiSolidEditAlt className="w-4 h-4" />
                        </button>
                      )}
                      {onDelete && (
                        <button
                          title="Delete"
                          className="p-[6px] bg-red-100 text-red-600 rounded hover:bg-red-200"
                          onClick={() => onDelete(row)}
                        >
                          <MdDeleteForever className="w-4 h-4" />
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={
                  cols.length + (showActions ? 1 : 0) + (checkbox ? 1 : 0)
                }
                className="text-center py-5 text-gray-400 border border-slate-200"
              >
                {noRecordsMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
